module.exports = [
  ...require('./_magicItemRawList_DMG_s'),
  require('./sword_of_kas'),
  require('./sword_of_sharpness'),
]
